module.exports = __webpack_public_path__ + "b7447254e0d72b92b3604cfc0b9f8341.png";